import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import ClaimComplaint from '../../entities/customercare/claimcomplaint'
import Claim from '../../entities/customercare/claim'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface ClaimComplaintState extends ListState<ClaimComplaint>{
    editModel: ClaimComplaint;
    claim: number;
    itemLoading: boolean;
}
class ClaimComplaintModule extends ListModule<ClaimComplaintState,any,ClaimComplaint>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<ClaimComplaint>(),
        loading: false,
        itemLoading: false,
        editModel: new ClaimComplaint(),
        activeList: new Array<ClaimComplaint>(),
        claim: 0,
        path: 'claim-complaints'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        init(state: ClaimComplaintState, model: Claim) {
            state.editModel = Object.assign({});
            state.claim = 0;
            if (model != undefined) {
                state.claim = model.id;
            }
        },
        new(state: ClaimComplaintState, model: ClaimComplaint) {
            state.editModel = Object.assign({});
        },
    });
}
const claimcomplaintModule=new ClaimComplaintModule();
export default claimcomplaintModule;
